let logo = 'data:image/svg+xml;base64,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';


import Vue from 'vue';
import Chart from 'vue2-frappe';
import VueTippy, { TippyComponent } from 'vue-tippy';
import VueLogger from 'vuejs-logger';
import { sync } from 'vuex-router-sync';

import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

import App from '@/App.vue';
import store from '@/store';
import router from '@/router';

import { IMaskDirective } from 'vue-imask';
import vPreventBodyScroll from '@/directives/prevent-body-scroll';
import windowSizeToStore from '@/directives/window-size-to-store.js';
import { checkAuth } from '@/utilites';
// old ui
import NiceIcon from '@/ui/nice-icon';
import NiceButton from '@/ui/nice-button';
// new ui
import NiceButton2 from '@/ui/nice-button-2';
import NiceIcon2 from '@/ui/nice-icon-2';
import NiceLabel from '@/ui/nice-label';

import { i18n } from '@/i18n.js';
// w/o tokens
import { get_uioverrides } from '@/api/request';
import { enableUIOverrides } from '@/uioverrides';

// toasted notifications
import Toasted from 'vue-toasted';

// loading circle
import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

// custom plugins
import FiltersPlugin from '@/plugins/filters.js';
import AsyncSet from '@/plugins/async-set.js';

// yandex metrika
import VueYandexMetrika from 'vue-yandex-metrika';

// imask directive
Vue.directive('imask', IMaskDirective);

// Apply filters plugin
Vue.use(FiltersPlugin);
Vue.use(AsyncSet);

Vue.config.productionTip = false;

// logger
Vue.use(VueLogger, {
	isEnabled: true,
	logLevel: process.env.VUE_APP_LOG_LEVEL,
	stringifyArguments: false,
	showLogLevel: true,
	showMethodName: true,
	separator: '|',
	showConsoleColors: true
});

// error logging in sentry
window.Sentry = Sentry;
if (process.env.VUE_APP_SENTRY_DSN) {
	Sentry.init({
		dsn: process.env.VUE_APP_SENTRY_DSN,
		// TODO: sentry has new recommended setup
		integrations: [
			new Integrations.Vue({Vue, attachProps: true}),
		],
	});
}


// apply frappe component
Vue.use(Chart);

// toasted notifications
Vue.use(Toasted);

// apply Tippy
Vue.use(VueTippy, {
	animateFill: false,
	animation: 'fade',
	arrow: true,
	duration: 100,
	theme: 'nice',
	flipDuration: 0,
	// popperOptions: {
	// 	modifiers: {
	// 		preventOverflow: { enabled: false, },
	// 		hide: { enabled: false, },
	// 	},
	// },
});

Vue.component('Tippy', TippyComponent);


// directives
Vue.directive('windowSizeToStore', windowSizeToStore);
Vue.use(vPreventBodyScroll);


// UI
// old
Vue.component('NiceIcon', NiceIcon);
Vue.component('NiceButton', NiceButton);
// new
Vue.component('NiceButton2', NiceButton2);
Vue.component('NiceIcon2', NiceIcon2);
Vue.component('NiceLabel', NiceLabel);


// inject `$router` into the `store` object
store.$router = router;


// need to be after our hacks with router and store
// eslint-disable-next-line
const unsync = sync(store, router);

// chain pre vue checks and calls
Promise.all([
	checkAuth(store),
	get_uioverrides(),
]).then(values => {
	// check and set language for WL domain
	const overrides = values[1].data || {};

	if (overrides.available_locales) {
		store.commit('profile/setAvailableLocales', overrides.available_locales);
	}

	if (overrides.default_language && !store.getters['profile/isLanguageSet']) {
		store.commit('profile/setLanguage', overrides.default_language);

		// reget UI override settings with a correct language
		return get_uioverrides();
	}

	return values[1];
}).then(overridesResponse => {
	let getProfilePromise = true;
	if (store.state.app.agency && store.state.profile.token) {
		getProfilePromise = store.dispatch('profile/getProfile', true);
	}

	const overrides = overridesResponse.data || {};

	// TODO: set available_locales again?
	if (overrides.available_locales) {
		store.commit('profile/setAvailableLocales', overrides.available_locales);
	}

	enableUIOverrides(Vue, store, overrides);

	// loading circle
	Vue.use(VueLoading, {
		color: overrides.main_color || '#2DC3B7'
	});

	// apply yandex metrika
	const yandex_metrika_id = overrides.yandex_metrika_id || process.env.VUE_APP_YANDEX_METRIKA;
	if (yandex_metrika_id) {
		Vue.use(VueYandexMetrika, {
			id: yandex_metrika_id,
			router: router,
			env: process.env.NODE_ENV // Metrika turns on only if `env` is 'production'
		});
	}

	// just to show in the console
	if (overrides.logo) {
		logo = overrides.logo;
	}

	return getProfilePromise;
}).then(() => {
	console.log( // eslint-disable-line no-console
		'%c+',
		`font-size: 1px; padding: 27px; line-height: 0; background: url("${logo}"); background-size: 34px 34px; background-repeat: no-repeat; background-position: center; color: transparent;`
	);
	console.debug( // eslint-disable-line no-console
		`%c ${process.env.VUE_APP_CURRENT_GIT_BRANCH} %c ${process.env.VUE_APP_CURRENT_GIT_COMMIT} %c`,
		'background: #35495e; padding: 1px; border-radius: 3px 0 0 3px; color: #fff',
		'background: #41b883; padding: 1px; border-radius: 0 3px 3px 0; color: #fff',
		'background:transparent'
	);

	// start vue
	new Vue({
		i18n,
		router,
		store,
		render: h => h(App),
	}).$mount('#app');
});
